"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIORITY_QUEUE_RESPONSE_EXAMPLE = exports.SKIP_PATIENT_RESPONSE_EXAMPLE = exports.RECALL_PATIENT_RESPONSE_EXAMPLE = exports.MOVE_QUEUE_RESPONSE_EXAMPLE = exports.GENERATE_TOKEN_RESPONSE_EXAMPLE = exports.GENERATE_QUEUE_RESPONSE_EXAMPLE = void 0;
/**
 * Response DTOs for the 6 Queue endpoints — reuses `AppointmentQueueDto`/
 * `QueueTokenDto` (`appointment-common.response.ts`); `priorityQueue`
 * returns a bare number, matching `PriorityQueueService`/
 * `QueueApplicationService.resolvePriority()`'s own no-wrapper shape.
 */
const appointment_common_response_1 = require("./appointment-common.response");
exports.GENERATE_QUEUE_RESPONSE_EXAMPLE = appointment_common_response_1.APPOINTMENT_QUEUE_RESPONSE_EXAMPLE;
exports.GENERATE_TOKEN_RESPONSE_EXAMPLE = appointment_common_response_1.QUEUE_TOKEN_RESPONSE_EXAMPLE;
exports.MOVE_QUEUE_RESPONSE_EXAMPLE = appointment_common_response_1.APPOINTMENT_QUEUE_RESPONSE_EXAMPLE;
exports.RECALL_PATIENT_RESPONSE_EXAMPLE = { ...appointment_common_response_1.APPOINTMENT_QUEUE_RESPONSE_EXAMPLE, status: 'CALLED' };
exports.SKIP_PATIENT_RESPONSE_EXAMPLE = { ...appointment_common_response_1.APPOINTMENT_QUEUE_RESPONSE_EXAMPLE, status: 'SKIPPED' };
exports.PRIORITY_QUEUE_RESPONSE_EXAMPLE = { priorityTier: 100 };
//# sourceMappingURL=queue.response.js.map